module.exports = __webpack_public_path__ + "static/media/Diginanny for Broadcasters.a36e4764.png";